import * as React from 'react';
import { useTheme } from '../../../theme';

const ServiceSummaryDivider: React.FC = ({ children }) => {
	const theme = useTheme('ServiceSummary').ServiceSummaryDivider;

	return <div className={theme.container}>{children}</div>;
};

export default ServiceSummaryDivider;
